/* eslint-disable react/prop-types */
import React from 'react';
interface IconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const SpinnerIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  className = '',
}) => {
  // Ensure numeric values for width and height
  const parsedWidth = Number(width) || 24;
  const parsedHeight = Number(height) || 24;

  // Calculate the viewBox dynamically
  const viewBox = `0 0 ${parsedWidth} ${parsedHeight}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={parsedWidth}
      height={parsedHeight}
      viewBox={viewBox}
      fill="none"
      className={` ${className} animate-spin`}
    >
      <path
        d="M12.4999 4.1999C8.19208 4.1999 4.6999 7.69208 4.6999 11.9999C4.6999 12.497 4.29696 12.8999 3.7999 12.8999C3.30285 12.8999 2.8999 12.497 2.8999 11.9999C2.8999 6.69797 7.19797 2.3999 12.4999 2.3999C17.8018 2.3999 22.0999 6.69797 22.0999 11.9999C22.0999 17.3018 17.8018 21.5999 12.4999 21.5999C12.0028 21.5999 11.5999 21.197 11.5999 20.6999C11.5999 20.2028 12.0028 19.7999 12.4999 19.7999C16.8077 19.7999 20.2999 16.3077 20.2999 11.9999C20.2999 7.69208 16.8077 4.1999 12.4999 4.1999Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default SpinnerIcon;
